/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work regularly with local files`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经常处理本地文件`)
};

/**
* | output |
* | --- |
* | "Work regularly with local files" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_0 as "gc.search_guides.what_is_gridcraft.sections.3.table.rows.1.0" }